import { useMemo } from 'react'
import { calculateDeckStats } from '@/utils/deckStats'
import type { DeckStatsInput, LeaderInput, CalculatedDeckStats } from '@/utils/deckStats'

/**
 * React hook wrapper for deck statistics calculation.
 * Memoizes the result based on cards and leader changes.
 */
export function useDeckStats(cards: DeckStatsInput[], leader?: LeaderInput | null): CalculatedDeckStats {
  return useMemo(() => calculateDeckStats(cards, leader), [cards, leader])
}
